import { IApiClientOptions } from 'core';
import {
    ICustomerKey,
    IUploadCustomerKeyOptions,
    IDistributeKeyRequestOptions,
    IDistributeKeyResponseResult,
    KcvPspKeyDto,
    IKeyTypeSupportMapped,
    IUploadCustomerKeyResponse,
    IClientPspEncryptionType,
    PSP,
} from '../dto/key-management/key-dto';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import { KeyDistributionResultDto } from 'dto/device-dto';
import { transform } from 'dto/transformer';

export class KeyApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('key', options);
    }

    protected getRootPath(): string {
        return '/keys';
    }

    public async getInventoryKeys(): Promise<ICustomerKey[]> {
        const responseResult = await this.getAllEntities<{ keys: ICustomerKey[] }>();
        return responseResult.keys;
    }

    public async createKeys(key: IUploadCustomerKeyOptions, files?: File[]): Promise<IUploadCustomerKeyResponse> {
        const responseResult = await this.send<IUploadCustomerKeyResponse>(HTTP_METHOD.POST, this.getRequestOptions('store', {
            uploadKeyProps: key,
            files
        }));
        return responseResult;
    }

    public async deleteKey(id: number): Promise<boolean> {
        const response = await this.deleteEntity<{ result: boolean }>({ id });
        return response.result;
    }

    public async distributeKey(options: IDistributeKeyRequestOptions): Promise<{ result: IDistributeKeyResponseResult[] }> {
        return this.send<{result: IDistributeKeyResponseResult[]}>(HTTP_METHOD.POST, this.getRequestOptions('distribute', options));
    }

    public async getKeyInventory(accountId: number, deviceIdentifier: string): Promise<KeyDistributionResultDto[]> {
        const result = await this.send<{ keys: Object[]; }>(HTTP_METHOD.GET, this.getRequestOptions('inventory', { accountId, deviceIdentifier }));
        return transform(KeyDistributionResultDto, result.keys);
    }

    public getKcvPspKeys(accountUuid: string, psp: string): Promise<KcvPspKeyDto> {
        return this.send<KcvPspKeyDto>(HTTP_METHOD.GET, this.getRequestOptions('kcv', { accountUuid, psp }));
    }

    public getSupportedKeyTypes(): Promise<IKeyTypeSupportMapped> {
        return this.send(HTTP_METHOD.GET, this.getRequestOptions('supported-key-types'));
    }

    public async getKmsAccountsWithValidPspData(): Promise<{ accountUuids: string[] }> {
        return this.send<{ accountUuids: string[] }>(HTTP_METHOD.GET, this.getRequestOptions('valid-psp'));
    }

    public async getPspEncryptionTypesOfAccount(accountUuid: string, fullyKeyConfigured: boolean = false): Promise<IClientPspEncryptionType[]> {
        const result = await this.send<{ pspEncryptionTypes: IClientPspEncryptionType[] }>(HTTP_METHOD.GET, this.getRequestOptions('psp-encryption-types', { accountUuid, fullyKeyConfigured }));
        return result.pspEncryptionTypes;
    }

    public async getKmsAccountUuidsByPspKeyTypes(pspKeyTypes: PSP[]): Promise<{ accountUuids: string[] }> {
        return this.send<{ accountUuids: string[] }>(HTTP_METHOD.GET, this.getRequestOptions('psp-key-types', { pspKeyTypes }));
    }
}
